"use client"

import type { QuickServiceProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { twMerge } from "tailwind-merge"
import { useQuickService } from "../../../../../../../hook/useQuickService"
import { generateResponsiveCSS } from "../../../lib/helper"
import { QuickServiceContent } from "./components/QuickServiceContent"

export const RenderConfig: ComponentConfig<QuickServiceProps> = {
  render: ({
    title,
    items,
    className,
    styles,
    responsiveType,
    id: componentId,
  }: QuickServiceProps & { id?: string }) => {
    const { id } = useQuickService({
      items,
      componentId,
    })

    const mergedStyles = styles || {}
    const responsiveCSS = generateResponsiveCSS(id, mergedStyles, responsiveType || "mobileFirst")

    return (
      <>
        {responsiveCSS}
        <QuickServiceContent id={id} title={title} items={items} className={twMerge(className)} />
      </>
    )
  },
}
